import { schema } from 'normalizr';

import constants from './constants';

const countrySchema = new schema.Entity(constants.NAME);
export const countryListSchema = [countrySchema];
